import React, { Fragment, useState } from "react";
import Collapse from "react-bootstrap/Collapse";
// import "./Home.scss";
import { Link } from "react-router-dom";
import Button from "../../components/Button/Button";
import plus from "../../assets/images/plus.png";
import cross from "../../assets/images/cross.png";
import horizontalLine from "../../assets/images/horizontalLine.png";

function FaqCollapsible(props) {
  const [first, setFirstOpen] = useState(false);
  const [second, setSecondOpen] = useState(false);
  const [third, setThirdOpen] = useState(false);
  const [fourth, setFourthOpen] = useState(false);
  const [fifth, setFifthOpen] = useState(false);
  const [sixth, setSixthOpen] = useState(false);
  const [seventh, setSeventhOpen] = useState(false);
  const [eight, setEightOpen] = useState(false);
  const [nine, setNineOpen] = useState(false);
  const [ten, setTenOpen] = useState(false);
  const [eleven, setElevenOpen] = useState(false);
  const [twelve, setTwelveOpen] = useState(false);
  const [thirteen, setThirteenOpen] = useState(false);
  const [fourTeen, setfourTeenOpen] = useState(false);
  const [fiteen, setFiteenOpen] = useState(false);
  const [sixteen, setSixteenOpen] = useState(false);
  const [showAllFAQ, setShowFaq] = useState(false);
  return (
    <Fragment>
      <div className="d-flex flex-column mb-3">
        <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
          <span className="text_43">Is this a sub-broker model platform?</span>
          <a
            onClick={() => setFirstOpen(!first)}
            aria-controls="finapp-account"
            aria-expanded={first}
          >
            {!first && <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />}
            {first && <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />}
          </a>
        </div>
        {!first && (
          <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
        )}
        <Collapse in={first}>
          <div id="finapp-account">
            <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
              No. You do business with your own ARN/RIA code. We are bridging the Technology & Algo
              gap that you have been facing so far.
            </span>
          </div>
        </Collapse>
      </div>
      <div className="d-flex flex-column mb-3">
        <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
          <span className="text_43">
            What's the thought process behind this platform? What’s in store for me?
          </span>
          <a
            onClick={() => setSecondOpen(!second)}
            aria-controls="finapp-benefit"
            aria-expanded={second}
          >
            {!second && <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />}
            {second && <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />}
          </a>
        </div>
        {!second && (
          <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
        )}
        <Collapse in={second}>
          <div id="finapp-benefit">
            <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
              We have been working with Family Offices & Robo Advisors powering their Research &
              Portfolios. Thru FinApp, we are offering our collective intelligence & experience, as
              a software to you & your clients
            </span>
          </div>
        </Collapse>
      </div>
      <div className="d-flex flex-column mb-3">
        <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
          <span className="text_43">Is this platform open to investors too?</span>
          <a
            onClick={() => setThirdOpen(!third)}
            aria-controls="dashboard-change"
            aria-expanded={third}
          >
            {!third && <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />}
            {third && <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />}
          </a>
        </div>
        {!third && (
          <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
        )}
        <Collapse in={third}>
          <div id="dashboard-change">
            <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
              Investor can access FinApp only through an existing Advisor. An investor will have to
              provide an Advisor Code during sign up without which they can't access the platform
            </span>
          </div>
        </Collapse>
      </div>
      <div className="d-flex flex-column mb-3">
        <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
          <span className="text_43">What's Advisor Code?</span>
          <a
            onClick={() => setFourthOpen(!fourth)}
            aria-controls="goal-planning"
            aria-expanded={fourth}
          >
            {!fourth && <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />}
            {fourth && <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />}
          </a>
        </div>
        {!fourth && (
          <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
        )}
        <Collapse in={fourth}>
          <div id="goal-planning">
            <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
              It’s a unique code that we will assign when you sign up as an Advisor.
            </span>
          </div>
        </Collapse>
      </div>
      <div className="d-flex flex-column mb-3">
        <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
          <span className="text_43">Can anyone sign up as an Advisor?</span>
          <a
            onClick={() => setFifthOpen(!fifth)}
            aria-controls="two-finapp-accounts"
            aria-expanded={fifth}
          >
            {!fifth && <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />}
            {fifth && <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />}
          </a>
        </div>
        {!fifth && (
          <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
        )}
        <Collapse in={fifth}>
          <div id="two-finapp-accounts">
            <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
              No. Only AMFI certified holders & RIAs can register as Advisors.
            </span>
          </div>
        </Collapse>
      </div>
      {showAllFAQ && (
        <>
          {/* <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">Do I have to pay a fee for sign up?</span>
              <a
                onClick={() => setSixthOpen(!sixth)}
                aria-controls="finapp-benefit"
                aria-expanded={sixth}
              >
                {!sixth && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {sixth && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!sixth && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={sixth}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  No, its free.
                </span>
              </div>
            </Collapse>
          </div> */}
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">Do I have to pay a fee for sign up?</span>
              <a
                onClick={() => setSeventhOpen(!seventh)}
                aria-controls="finapp-benefit"
                aria-expanded={seventh}
              >
                {!seventh && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {seventh && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!seventh && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={seventh}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  No, its free.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">What can I do after signing up?</span>
              <a
                onClick={() => setEightOpen(!eight)}
                aria-controls="finapp-benefit"
                aria-expanded={eight}
              >
                {!eight && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {eight && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!eight && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={eight}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  You can create clients. Check out the comprehensive fund research tool. See the
                  portfolio analysis, re-balancing recommendations. Set up Model Portfolios. Your
                  practice is getting automated, efficient & sharp in a few hours.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">Sounds good. How easy is the migration?</span>
              <a
                onClick={() => setNineOpen(!nine)}
                aria-controls="finapp-benefit"
                aria-expanded={nine}
              >
                {!nine && <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />}
                {nine && <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />}
              </a>
            </div>
            {!nine && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={nine}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  It is super easy. Just upload your transaction feeds from RTAs. Your clients would
                  be created in an hour & you can start seeing all Portfolio Reports, Optimization
                  Models etc.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">
                Awesome. What value can I bring to my clients through this system?
              </span>
              <a
                onClick={() => setTenOpen(!ten)}
                aria-controls="finapp-benefit"
                aria-expanded={ten}
              >
                {!ten && <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />}
                {ten && <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />}
              </a>
            </div>
            {!ten && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={ten}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  Terrific value. From on-boarding to robust advice to seamless transactions to
                  insightful reporting, FinApp would be an experience that your client had longed
                  for.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">What all activities can the client perform?</span>
              <a
                onClick={() => setElevenOpen(!eleven)}
                aria-controls="finapp-benefit"
                aria-expanded={eleven}
              >
                {!eleven && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {eleven && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!eleven && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={eleven}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  Clients can upload their CAS, do Risk Profiling, Goal Planning & Invest in Model
                  Portfolios set by you.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">
                Can we configure Model Portfolios or is it given by Pulse Labs?
              </span>
              <a
                onClick={() => setTwelveOpen(!twelve)}
                aria-controls="finapp-benefit"
                aria-expanded={twelve}
              >
                {!twelve && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {twelve && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!twelve && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={twelve}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  We will give you a framework and you can configure your own Portfolios. If you
                  want to use our Model Portfolios, you can use it too.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">
                How does the Model Portfolio work? What's the process?
              </span>
              <a
                onClick={() => setThirteenOpen(!thirteen)}
                aria-controls="finapp-benefit"
                aria-expanded={thirteen}
              >
                {!thirteen && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {thirteen && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!thirteen && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={thirteen}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  There are 2 type of Model Portfolios that we offer. Strategic & Dynamic. Strategic
                  is aligned with the Goals & Risk Profile of the client. These would be fixed Asset
                  Allocatiion Models. Dynamic Portfolio is driven by an Algo that switches between
                  Cash & Equity. We recommend to have it for your HNI clients
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">Can you elaborate on the Dynamic Modeling?</span>
              <a
                onClick={() => setSixthOpen(!sixth)}
                aria-controls="finapp-benefit"
                aria-expanded={sixth}
              >
                {!sixth && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {sixth && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!sixth && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={sixth}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  Unlike the traditional Dynamic Asset Allocation Funds/Strategies that focuses on
                  Risk Mitigation alone, we have developed an Algo that optimizes between the Bull &
                  Bear phases. It combines Valuation & Momentum factors to trigger a re-balancing
                  action.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">How does the Re-balancing happen?</span>
              <a
                onClick={() => setFiteenOpen(!fiteen)}
                aria-controls="finapp-benefit"
                aria-expanded={fiteen}
              >
                {!fiteen && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {fiteen && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!fiteen && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={fiteen}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  As mentioned above, on Dynamic Model the re-balancing would happen based on the
                  Algo Trigger. On Goal based portfolios, re-balancing triggers would be given based
                  on the Returns required
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">Returns required? And what’s attribution analysis?</span>
              <a
                onClick={() => setSixteenOpen(!sixteen)}
                aria-controls="finapp-benefit"
                aria-expanded={sixteen}
              >
                {!sixteen && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {sixteen && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!sixteen && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={sixteen}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  Every portfolio is expected to achieve an ROI to fulfill the goal. Re-balancing
                  decisions should be based on this. We track this number & notify when to
                  re-balance at a client goal level. Attribution Analysis is recommended for HNIs.
                  It will showcase the path through which you have generated the returns in a
                  portfolio, such as % derived out of Asset Allocation, Fund Selection etc.
                </span>
              </div>
            </Collapse>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex flex-row  align-items-center justify-content-between mb-4">
              <span className="text_43">This is superb stuff. How can I start using FinApp ?</span>
              <a
                onClick={() => setfourTeenOpen(!fourTeen)}
                aria-controls="finapp-benefit"
                aria-expanded={fourTeen}
              >
                {!fourTeen && (
                  <img src={plus} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
                {fourTeen && (
                  <img src={cross} alt="images" style={{ width: "14px", height: "14px" }} />
                )}
              </a>
            </div>
            {!fourTeen && (
              <img src={horizontalLine} alt="images" style={{ width: "100%", height: "1px" }} />
            )}
            <Collapse in={fourTeen}>
              <div id="finapp-benefit">
                <span className="text_6" style={{ color: "rgba(26, 25, 30, 0.5) " }}>
                  Thanks! <Link onClick={()=>props.signupModal()}>Click Here</Link>
                </span>
              </div>
            </Collapse>
          </div>
        </>
      )}
      <div className="d-flex flex-column mb-3 mt-3">
        <div className="d-flex flex-row align-items-center justify-content-between">
          <Button
            type="button"
            size="lg"
            text={!showAllFAQ ? "View All FAQ’s" : "show less FAQ’s "}
            customClass={`col-md-4 al_btn_1`}
            onClick={() => setShowFaq(!showAllFAQ ? true : false)}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default FaqCollapsible;
